export default class Participant {
    constructor(id, first_name, last_name, birthyear, info, verified_status = "UNVERIFIED") {
        this.id = id;
        this.first_name = first_name;
        this.last_name = last_name;
        this.birthYear = birthyear;
        this.wsvInfo = info;
        this.verifiedStatus = verified_status;
    }

    get fullName() {
        return `${this.first_name} ${this.last_name}`;
    }
}